import { selectLoadPageUrl } from '../../common/selectors/meta';
import { experiments } from '../../experiments';
import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger } from '../types';
import {
  formatSuggestedQuestionsForBi,
  getKbWidgetState,
  getRuntimeDataForBi,
  getSuggestedQuestionsList,
} from '../utils';

export const logChatbotLoadChatbot: BiEventLogger = async (state) => {
  const biData = selectBiData(state);
  const { sessionId, contextBi, placement } = await getRuntimeDataForBi(state);
  const isResetButton = experiments.is('specs.chatbot.resetButton', 'true');
  const loadPageUrl = selectLoadPageUrl(state);
  const suggestedQuestionsList = getSuggestedQuestionsList(loadPageUrl);

  biLogger.chatbotLoadChatbot({
    ts: Date.now() - window.initialTimestamp,
    kb_widget_state: getKbWidgetState(state),
    chatbot_view: contextBi?.chatbot_view,
    lang: locale,
    placement,
    session_id: sessionId,
    conversation_id: biData.conversationId,
    node_id: biData.nodeId,
    context_area: contextBi?.context_area,
    context_domain: contextBi?.context_domain,
    context_msid: contextBi?.context_msid,
    context_page_numlevels: contextBi?.context_page_numlevels,
    context_page_queryparams: contextBi?.context_page_queryparams,
    context_page_toplevelroute: contextBi?.context_page_toplevelroute,
    context_page_urlchunks: contextBi?.context_page_urlchunks,
    context_parenturl: contextBi?.context_parenturl,
    context_platform: contextBi?.context_platform,
    context_uuid: contextBi?.context_uuid,
    user_experience: contextBi?.user_experience,
    mapping_product: contextBi?.mapping_product,
    mapping_url: contextBi?.mapping_url,
    context_iframeurllist: undefined,
    widget_view_mode: undefined,
    node_name: undefined,
    group_name: undefined,
    referral_info: undefined,
    ab_test_version: undefined,
    real_estate_id: undefined,
    offer_id: undefined,
    suggestion_id: undefined,
    chatbot_state: undefined,
    ai_user_intent: undefined,
    ai_user_intent_type: undefined,
    is_new_node: undefined,
    is_restart_icon: isResetButton,
    suggested_questions_list: formatSuggestedQuestionsForBi(suggestedQuestionsList),
  });
};
